<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
          <v-textarea
            v-model="form.codes"
            :label="$t('fields.code')"
            :hint="$t('fields.code')"
          ></v-textarea>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  export default {
    name: 'IncomingModal',
    data() {
      return {
        stored: null,
        form: {
          codes: null,
          type: 'boxin',
        },
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
    },
    async created() {
      this.loadingModal(true);
      this.loadingModal(false);
    },
  };
</script>
